import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_CHARGER_STATE, UPDATE_CHARGER_STATE } from 'actions/chargerState';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';

const ChargerStateForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const chargerStateDetail = useSelector((state) => state.chargerState.chargerStateDetail);
  const isLoading = useSelector((state) => state.chargerState.isLoading);

  const addChargerState = useCallback((data) => {
    dispatch({
      type: CREATE_CHARGER_STATE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateChargerState = useCallback((data) => {
    dispatch({
      type: UPDATE_CHARGER_STATE.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const ChargerStateSchema = Yup.object().shape({
    name: Yup.string().required(t('chargerStateForm.name')).strict(true).trim(t('chargerStateForm.space')).max(100, t('chargerStateForm.maxlimit')),

    cpo_code: Yup.number()
      .integer(t('chargerStateForm.integerOnly')) // Replace "chargerStateForm.integerOnly" with the error message for non-integer input
      .typeError(t('chargerStateForm.integerOnly')) // Replace "chargerStateForm.integerOnly" with the error message for non-integer input
      .required(t('chargerStateForm.cpo_code')), // Replace "chargerStateForm.cpoCodeRequired" with the error message for a required field
  });

  const initialValues = isEdit
    ? { ...chargerStateDetail }
    : {
        name: '',
        cpo_code: '',
      };
  return (
    <React.Fragment>
      <div className="chargerState-form-page__main">
        <Card>
          <div className="chargerState-form-header__block">
            <div className="chargerState-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} {t('chargerStateForm.title')}
              </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="chargerState-form-body__block">
            <div className="chargerState-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={ChargerStateSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateChargerState(values);
                  } else {
                    addChargerState(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label={t('chargerStateForm.cpoCode')}
                          placeholder={t('chargerStateForm.cpoCode')}
                          name="cpo_code"
                          value={_.get(values, 'cpo_code', '')}
                          onChange={handleChange}
                          error={errors.cpo_code && touched.cpo_code ? errors.cpo_code : null}
                        />
                        <TextInput
                          isRequired
                          label={t('chargerStateForm.name')}
                          placeholder={t('chargerStateForm.name')}
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      <Button className="form_btn cancel____btn" onClick={onClose}>
                        {t('button.cancel')}
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
ChargerStateForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default ChargerStateForm;
